var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlineacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.3333C28.3167 25.3333 25.3333 28.3167 25.3333 32C25.3333 35.6833 28.3167 38.6667 32 38.6667C35.6833 38.6667 38.6667 35.6833 38.6667 32C38.6667 28.3167 35.6833 25.3333 32 25.3333ZM46.9 30.3333C46.1333 23.3833 40.6167 17.8667 33.6667 17.1V13.6667H30.3333V17.1C23.3833 17.8667 17.8667 23.3833 17.1 30.3333H13.6667V33.6667H17.1C17.8667 40.6167 23.3833 46.1333 30.3333 46.9V50.3333H33.6667V46.9C40.6167 46.1333 46.1333 40.6167 46.9 33.6667H50.3333V30.3333H46.9ZM32 43.6667C25.55 43.6667 20.3333 38.45 20.3333 32C20.3333 25.55 25.55 20.3333 32 20.3333C38.45 20.3333 43.6667 25.55 43.6667 32C43.6667 38.45 38.45 43.6667 32 43.6667Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlineacion);
export default __webpack_public_path__ + "static/media/icon-alineacion.ee8b94418357d827a83516aa0ff91fba.svg";
export { ForwardRef as ReactComponent };